import { createAction, props } from '@ngrx/store';
import { OrderStatusFilters } from '@usf/user-types/user-preferencev2';

const postOrderStatusFilterPreferences = createAction(
  '[NgRx - Order Status] Post Order Status Filter Preferences',
  props<{
    orderStatusFilters: OrderStatusFilters;
    rememberSelections?: {
      orderStatus: boolean;
      customers: boolean;
      deliveryMethod: boolean;
      deliveryDatePreset: boolean;
    };
  }>(),
);

export const ORDER_STATUS_PAGE_ACTIONS = {
  postOrderStatusFilterPreferences,
};
